export const drawerVariantInitial = {
  opacity: 0,
};

export const drawerVariantAnimate = {
  opacity: 1,
  transition: { duration: 1 },
};
